<template>
  <div class="page_content module_course" aria-label="Course Section Channel">
    <div class="channel-section channel-modal-popup">
      <div class="channel-content-section">
        <template v-if="showChannelMenu">
          <div class="left-channel-panel left-panel-menu">
            <!-- == .channel_pg_hd == -->
            <template v-if="isChannelLoaded">
              <template v-if="channel">
                <div class="search_fld_container" v-if="(channelType !== 'ADVISOR')">
                  <span class="ic-filter"></span>
                  <input v-model="searchTerm" placeholder="type to narrow list" class="search_fld">
                  <template v-if="searchTerm.length > 0">
                    <b-btn class="btn_clear" title="clear" aria-label="clear" @click="searchTerm = ''">
                      <span class="ic-close"></span>
                    </b-btn>
                  </template>
                </div>
                <div class="content-section channel-list accordion" role="tablist" :class="searchTerm.length > 0 ? 'ch_srh_list_showing' : ''">
                  <template v-if="(channelType !== 'ADVISOR')">
                    <div class="sec_hd">
                      <b-button v-b-toggle.collapse-1 variant="primary">
                        <span class="ic_container">
                        <span class="ic-expand_r"></span>
                        <span class="ic-collapse_r"></span>
                        </span>
                      </b-button>
                      <span class="hd_txt" v-b-toggle.collapse-1>
                      Advisor Group Channels
                      </span>
                    </div>
                    <div class="lft_pan_sec">
                      <b-collapse id="collapse-1" :visible="isGroupChannelVisible" class="grp_ch_list" accordion="channel-list-accordion" role="tabpanel">
                        <b-card>
                          <template v-if="(channelType === 'ALL')">
                            <template v-for="(groupChannel, i) in filteredGroupChannels">
                              <div :id="'section-' + groupChannel.uuid" class="content-row" :class="{'active': (currentChannel === groupChannel.externalId)}" @click="loadChannelMessage(groupChannel, 'section-' + groupChannel.uuid)" v-if="groupChannel.entityType==='stream'">
                                <template v-if="isChannelRenameClicked && (selectedRenameElemId === 'section-' + groupChannel.uuid + '-' + i)">
                                  <div class="title" style="max-width: calc(100% - 92px);">
                                    <div class="ic11-channel"></div>
                                    <input type="text" v-model="channelName"></input>
                                  </div>
                                  <div @click.stop="cancelUpdateChannelName">
                                    <span class="fas fa-times cancel-name-icon" title="cancel"></span>
                                  </div>
                                  <div @click.stop="updateChannelName(groupChannel)" v-if="channelName && (channelName !== groupChannel.channelName)">
                                    <span class="fas fa-save save-name-icon" title="save"></span>
                                  </div>
                                </template>
                                <template v-else>
                                  <template v-if="channelMessageUnreadCount(groupChannel) > 0">
                                    <div class="title" style="max-width: calc(100% - 59px);">
                                      <div class="ic11-channel"></div>
                                      <div :title="groupChannel.channelName" class="title_txt unread-message-status">{{groupChannel.channelName}}</div>
                                    </div>
                                    <div class="unread-message-count">{{channelMessageUnreadCount(groupChannel)}}</div>
                                    <div v-if="(groupChannel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(groupChannel, 'section-' + groupChannel.uuid + '-' + i)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="title">
                                      <div class="ic11-channel"></div>
                                      <div class="title_txt" :title="groupChannel.channelName">{{groupChannel.channelName}}</div>
                                    </div>
                                    <div v-if="(groupChannel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(groupChannel, 'section-' + groupChannel.uuid + '-' + i)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                </template>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="filteredChannelName">
                              <div :id="'section-' + channel.uuid" class="content-row" :class="{'active': (currentChannel === uuid)}" @click="loadChannelMessage(channel, 'section-' + channel.uuid)">
                                <template v-if="isChannelRenameClicked && (selectedRenameElemId === 'section-' + channel.uuid)">
                                  <div class="title" style="max-width: calc(100% - 92px);">
                                    <div class="ic11-channel"></div>
                                    <input type="text" v-model="channelName"></input>
                                  </div>
                                  <div @click.stop="cancelUpdateChannelName">
                                    <span class="fas fa-times cancel-name-icon" title="cancel"></span>
                                  </div>
                                  <div @click="updateChannelName(channel)" v-if="channelName && (channelName !== channel.channelName)">
                                    <span class="fas fa-save save-name-icon" title="save"></span>
                                  </div>
                                </template>
                                <template v-else>
                                  <template v-if="channelMessageUnreadCount(channel) > 0">
                                    <div class="title" style="max-width: calc(100% - 100px);">
                                      <div class="ic11-channel"></div>
                                      <div :title="channel.channelName" class="unread-message-status">{{channel.channelName}}</div>
                                    </div>
                                    <div class="unread-message-count">{{channelMessageUnreadCount(channel)}}</div>
                                    <div v-if="(channel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click.stop="clickChannelNameEdit(channel, 'section-' + channel.uuid)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="title">
                                      <div class="ic11-channel"></div>
                                      <div class="title_txt" :title="channel.channelName">{{channel.channelName}}</div>
                                    </div>
                                    <div v-if="(channel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(channel, 'section-' + channel.uuid)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                </template>
                              </div>
                            </template>
                            <div :id="'section-group-participant-' + group.groupId" class="content-row" v-for="group in filteredStudyGroups" :key="'section-group-' + group.groupId" @click="loadGroupMessage(group)" :class="{'current-user': (selectedGroup && (selectedGroup.groupId === group.groupId)), 'active': (selectedGroup && (selectedGroup.groupId === group.groupId)), 'unread-message-status': (groupMessageUnreadCount(group) > 0)}" v-if="group.participantIds.includes(userId)">
                              <div class="title" style="margin-top: 0px; max-width: calc(100% - 125px) !important;">
                                <div class="ic11-channel"></div>
                                <div :title="group.groupName">{{group.groupName}}</div>
                              </div>
                              <div class="unread-message-count" v-if="groupMessageUnreadCount(group) > 0">{{groupMessageUnreadCount(group)}}</div>
                              <div class="ic_container">
                                <span class="fa fa-trash delete-group-icon" :id="group.groupId" v-if="(userId === group.createdById)" @click.stop="showDeleteGroupConfirmModal(group)" title="Delete Group" aria-hidden="true"></span>
                              </div>
                            </div>
                          </template>
                        </b-card>
                      </b-collapse>
                    </div>
                    <div class="sec_hd">
                      <b-button v-b-toggle.collapse-2 variant="primary">
                        <span class="ic_container">
                        <span class="ic-expand_r"></span>
                        <span class="ic-collapse_r"></span>
                        </span>
                      </b-button>
                      <span class="hd_txt" v-b-toggle.collapse-2>
                      Course Channels
                      </span>
                    </div>
                    <div class="lft_pan_sec">
                      <b-collapse id="collapse-2" :visible="isGroupChannelVisible" class="grp_ch_list" accordion="channel-list-accordion" role="tabpanel">
                        <b-card>
                          <template v-if="(channelType === 'ALL')">
                            <template v-for="(groupChannel, i) in filteredGroupChannels">
                              <div :id="'section-' + groupChannel.uuid" class="content-row" :class="{'active': (currentChannel === groupChannel.externalId)}" @click="loadChannelMessage(groupChannel, 'section-' + groupChannel.uuid)" v-if="groupChannel.entityType==='section'">
                                <template v-if="isChannelRenameClicked && (selectedRenameElemId === 'section-' + groupChannel.uuid + '-' + i)">
                                  <div class="title" style="max-width: calc(100% - 92px);">
                                    <div class="ic11-channel"></div>
                                    <input type="text" v-model="channelName"></input>
                                  </div>
                                  <div @click.stop="cancelUpdateChannelName">
                                    <span class="fas fa-times cancel-name-icon" title="cancel"></span>
                                  </div>
                                  <div @click.stop="updateChannelName(groupChannel)" v-if="channelName && (channelName !== groupChannel.channelName)">
                                    <span class="fas fa-save save-name-icon" title="save"></span>
                                  </div>
                                </template>
                                <template v-else>
                                  <template v-if="channelMessageUnreadCount(groupChannel) > 0">
                                    <div class="title" style="max-width: calc(100% - 59px);">
                                      <div class="ic11-channel"></div>
                                      <div :title="groupChannel.channelName" class="title_txt unread-message-status">{{groupChannel.channelName}}</div>
                                    </div>
                                    <div class="unread-message-count">{{channelMessageUnreadCount(groupChannel)}}</div>
                                    <div v-if="(groupChannel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(groupChannel, 'section-' + groupChannel.uuid + '-' + i)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="title">
                                      <div class="ic11-channel"></div>
                                      <div class="title_txt" :title="groupChannel.channelName">{{groupChannel.channelName}}</div>
                                    </div>
                                    <div v-if="(groupChannel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(groupChannel, 'section-' + groupChannel.uuid + '-' + i)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                </template>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="filteredChannelName">
                              <div :id="'section-' + channel.uuid" class="content-row" :class="{'active': (currentChannel === uuid)}" @click="loadChannelMessage(channel, 'section-' + channel.uuid)">
                                <template v-if="isChannelRenameClicked && (selectedRenameElemId === 'section-' + channel.uuid)">
                                  <div class="title" style="max-width: calc(100% - 92px);">
                                    <div class="ic11-channel"></div>
                                    <input type="text" v-model="channelName"></input>
                                  </div>
                                  <div @click.stop="cancelUpdateChannelName">
                                    <span class="fas fa-times cancel-name-icon" title="cancel"></span>
                                  </div>
                                  <div @click="updateChannelName(channel)" v-if="channelName && (channelName !== channel.channelName)">
                                    <span class="fas fa-save save-name-icon" title="save"></span>
                                  </div>
                                </template>
                                <template v-else>
                                  <template v-if="channelMessageUnreadCount(channel) > 0">
                                    <div class="title" style="max-width: calc(100% - 100px);">
                                      <div class="ic11-channel"></div>
                                      <div :title="channel.channelName" class="unread-message-status">{{channel.channelName}}</div>
                                    </div>
                                    <div class="unread-message-count">{{channelMessageUnreadCount(channel)}}</div>
                                    <div v-if="(channel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click.stop="clickChannelNameEdit(channel, 'section-' + channel.uuid)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="title">
                                      <div class="ic11-channel"></div>
                                      <div class="title_txt" :title="channel.channelName">{{channel.channelName}}</div>
                                    </div>
                                    <div v-if="(channel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(channel, 'section-' + channel.uuid)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                </template>
                              </div>
                            </template>
                            <div :id="'section-group-participant-' + group.groupId" class="content-row" v-for="group in filteredStudyGroups" :key="'section-group-' + group.groupId" @click="loadGroupMessage(group)" :class="{'current-user': (selectedGroup && (selectedGroup.groupId === group.groupId)), 'active': (selectedGroup && (selectedGroup.groupId === group.groupId)), 'unread-message-status': (groupMessageUnreadCount(group) > 0)}" v-if="group.participantIds.includes(userId)">
                              <div class="title" style="margin-top: 0px; max-width: calc(100% - 125px) !important;">
                                <div class="ic11-channel"></div>
                                <div :title="group.groupName">{{group.groupName}}</div>
                              </div>
                              <div class="unread-message-count" v-if="groupMessageUnreadCount(group) > 0">{{groupMessageUnreadCount(group)}}</div>
                              <div class="ic_container">
                                <span class="fa fa-trash delete-group-icon" :id="group.groupId" v-if="(userId === group.createdById)" @click.stop="showDeleteGroupConfirmModal(group)" title="Delete Group" aria-hidden="true"></span>
                              </div>
                            </div>
                          </template>
                        </b-card>
                      </b-collapse>
                    </div>
                    <div class="sec_hd">
                      <b-button v-b-toggle.collapse-3 variant="primary">
                        <span class="ic_container">
                        <span class="ic-expand_r"></span>
                        <span class="ic-collapse_r"></span>
                        </span>
                      </b-button>
                      <span class="hd_txt" v-b-toggle.collapse-3>
                      Group Channels
                      </span>
                    </div>
                    <div class="lft_pan_sec">
                      <b-collapse id="collapse-3" :visible="isGroupChannelVisible" class="grp_ch_list" accordion="channel-list-accordion" role="tabpanel">
                        <b-card>
                          <template v-if="(channelType === 'ALL')">
                            <template v-for="(groupChannel, i) in filteredGroupChannels">
                              <div :id="'section-' + groupChannel.uuid" class="content-row" :class="{'active': (currentChannel === groupChannel.externalId)}" @click="loadChannelMessage(groupChannel, 'section-' + groupChannel.uuid)" v-if="groupChannel.entityType!=='section' && groupChannel.entityType!=='stream'">
                                <template v-if="isChannelRenameClicked && (selectedRenameElemId === 'section-' + groupChannel.uuid + '-' + i)">
                                  <div class="title" style="max-width: calc(100% - 92px);">
                                    <div class="ic11-channel"></div>
                                    <input type="text" v-model="channelName"></input>
                                  </div>
                                  <div @click.stop="cancelUpdateChannelName">
                                    <span class="fas fa-times cancel-name-icon" title="cancel"></span>
                                  </div>
                                  <div @click.stop="updateChannelName(groupChannel)" v-if="channelName && (channelName !== groupChannel.channelName)">
                                    <span class="fas fa-save save-name-icon" title="save"></span>
                                  </div>
                                </template>
                                <template v-else>
                                  <template v-if="channelMessageUnreadCount(groupChannel) > 0">
                                    <div class="title" style="max-width: calc(100% - 59px);">
                                      <div class="ic11-channel"></div>
                                      <div :title="groupChannel.channelName" class="title_txt unread-message-status">{{groupChannel.channelName}}</div>
                                    </div>
                                    <div class="unread-message-count">{{channelMessageUnreadCount(groupChannel)}}</div>
                                    <div v-if="(groupChannel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(groupChannel, 'section-' + groupChannel.uuid + '-' + i)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="title">
                                      <div class="ic11-channel"></div>
                                      <div class="title_txt" :title="groupChannel.channelName">{{groupChannel.channelName}}</div>
                                    </div>
                                    <div v-if="(groupChannel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(groupChannel, 'section-' + groupChannel.uuid + '-' + i)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                </template>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="filteredChannelName">
                              <div :id="'section-' + channel.uuid" class="content-row" :class="{'active': (currentChannel === uuid)}" @click="loadChannelMessage(channel, 'section-' + channel.uuid)">
                                <template v-if="isChannelRenameClicked && (selectedRenameElemId === 'section-' + channel.uuid)">
                                  <div class="title" style="max-width: calc(100% - 92px);">
                                    <div class="ic11-channel"></div>
                                    <input type="text" v-model="channelName"></input>
                                  </div>
                                  <div @click.stop="cancelUpdateChannelName">
                                    <span class="fas fa-times cancel-name-icon" title="cancel"></span>
                                  </div>
                                  <div @click="updateChannelName(channel)" v-if="channelName && (channelName !== channel.channelName)">
                                    <span class="fas fa-save save-name-icon" title="save"></span>
                                  </div>
                                </template>
                                <template v-else>
                                  <template v-if="channelMessageUnreadCount(channel) > 0">
                                    <div class="title" style="max-width: calc(100% - 100px);">
                                      <div class="ic11-channel"></div>
                                      <div :title="channel.channelName" class="unread-message-status">{{channel.channelName}}</div>
                                    </div>
                                    <div class="unread-message-count">{{channelMessageUnreadCount(channel)}}</div>
                                    <div v-if="(channel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click.stop="clickChannelNameEdit(channel, 'section-' + channel.uuid)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="title">
                                      <div class="ic11-channel"></div>
                                      <div class="title_txt" :title="channel.channelName">{{channel.channelName}}</div>
                                    </div>
                                    <div v-if="(channel.ownerId === userId)" class="ic_container">
                                      <span class="icon-pencil edit-name-icon" @click="clickChannelNameEdit(channel, 'section-' + channel.uuid)" style="cursor: pointer;" title="Rename"></span>
                                    </div>
                                  </template>
                                </template>
                              </div>
                            </template>
                            <div :id="'section-group-participant-' + group.groupId" class="content-row" v-for="group in filteredStudyGroups" :key="'section-group-' + group.groupId" @click="loadGroupMessage(group)" :class="{'current-user': (selectedGroup && (selectedGroup.groupId === group.groupId)), 'active': (selectedGroup && (selectedGroup.groupId === group.groupId)), 'unread-message-status': (groupMessageUnreadCount(group) > 0)}" v-if="group.participantIds.includes(userId)">
                              <div class="title" style="margin-top: 0px; max-width: calc(100% - 125px) !important;">
                                <div class="ic11-channel"></div>
                                <div :title="group.groupName">{{group.groupName}}</div>
                              </div>
                              <div class="unread-message-count" v-if="groupMessageUnreadCount(group) > 0">{{groupMessageUnreadCount(group)}}</div>
                              <div class="ic_container">
                                <span class="fa fa-trash delete-group-icon" :id="group.groupId" v-if="(userId === group.createdById)" @click.stop="showDeleteGroupConfirmModal(group)" title="Delete Group" aria-hidden="true"></span>
                              </div>
                            </div>
                          </template>
                        </b-card>
                      </b-collapse>
                    </div>

                    <div class="sec_hd">
                      <b-button v-b-toggle.collapse-2 variant="primary">
                        <span class="ic_container">
                        <span class="ic-expand_r"></span>
                        <span class="ic-collapse_r"></span>
                        </span>
                      </b-button>
                      <span class="hd_txt" v-b-toggle.collapse-2>
                      Direct Channels
                      </span>
                      <div v-if="showAddDirectChannel" class="mt-1 mr-1 float-right" style="cursor: pointer;" @click="showCreateDirectChannelModal">
                        <span class="fa fa-plus" aria-hidden="true" title="Create Direct Channel" style="font-size: 20px;"></span>
                      </div>
                    </div>
                    <div class="lft_pan_sec">
                      <b-collapse id="collapse-2" :visible="isDirectChannelVisible" class="ch_direct" accordion="channel-list-accordion" role="tabpanel">
                        <b-card>
                          <div :id="'section-participant-' + participant.userUuid" class="content-row" v-for="participant in filteredDirectChannelParticipants" :key="'section-' + participant.userUuid" @click="loadOneToOneMessage(participant)" :class="{'current-user': (selectedUserId === participant.userUuid), 'active': (selectedUserId === participant.userUuid), 'unread-message-status': (directMessageUnreadCount(participant.userUuid) > 0)}">
                            <div class="title" :class="isLoadingOnWidget ? 'title-participant-widget' : 'title-participant'" style="margin-top: 0px;">
                              <div class="channel_sec">
                                <div class="user-avatar-default">
                                  <span class="ic-user">
                                  <span class="user-status" :class="{'user-status-online': isUserOnline(participant.userUuid)}"></span>
                                  </span>
                                </div>
                              </div>
                              <div class="title_txt">
                                <span :title="participant.displayName">{{participant.firstName}}</span>
                                <span v-if="(userId === participant.userUuid)" class="ml-2" style="color: #a0a0a0;">(you)</span>
                              </div>
                            </div>
                            <div class="unread-message-count" v-if="directMessageUnreadCount(participant.userUuid) > 0">{{directMessageUnreadCount(participant.userUuid)}}</div>
                          </div>
                        </b-card>
                      </b-collapse>
                    </div>
                  </template>
                </div>
              </template>
            </template>
            <div class="lft_pan_close_bar" @click="hideChannelListPanel">
              <b-btn class="btn_close p-0">
                <span class="ic-close"></span>
              </b-btn>
            </div>
          </div>
          <!-- == .left-channel-panel == -->
        </template>
        <div class="ch_rgt_panel">
          <div class="row page-heading channel_pg_hd">
            <div class="col-12 module_heading" v-if="isChannelLoaded">
              <template v-if="isDirectMessage">
                <div class="channel_sec mt-2">
                  <div class="user-avatar-default">
                    <span class="ic-user">
                    <span class="user-status"></span>
                    </span>
                  </div>
                </div>
                <div class="title float-left mt-1">
                  <span class="ml-2" id="selectedPeerNamePopover">{{selectedPeerName}}</span>
                  <b-popover target="selectedPeerNamePopover" triggers="hover" placement="top">
                    {{selectedPeerName}}
                  </b-popover>
                </div>
              </template>
              <template v-else-if="isGroupMessage">
                <div class="title" id="groupNamePopover">
                  <div class="ic11-channel"></div>
                  <div class="title_txt">{{selectedGroup.groupName}}</div>
                </div>
                <b-popover target="groupNamePopover" triggers="hover" placement="top">
                  {{selectedGroup.groupName}}
                </b-popover>
              </template>
              <template v-else class="hd_txt">
                <div class="hd_txt" v-if="((channelType === 'ALL') || (channelType === 'ADVISOR'))">
                  <template v-if="advisorChannel && isAdvisorChannel">
                    <div class="title">
                      <div class="ic11-channel"></div>
                      <div class="title_txt">Advisor's Channel</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="title" v-if="channel" id="channelNamePopover">
                      <div class="ic11-channel"></div>
                      <div class="title_txt">{{channel.channelName}}</div>
                    </div>
                  </template>
                </div>
                <div class="title" v-else id="channelNamePopover">
                  <div class="ic11-channel"></div>
                  <div class="title_txt">{{channel.channelName}}</div>
                </div>
                <b-popover target="channelNamePopover" triggers="hover" placement="top">
                  {{channel.channelName}}
                </b-popover>
              </template>
              <div class="btn_container" @click="$router.go(-1)">
                <div class="ic-close"></div>
              </div>
            </div>

            <div class="col-12 sub_hd">
              <button class="all_ch_btn" @click="showChannelMenu = !showChannelMenu">
                <span>show all channels</span>
              </button>
              <span v-if="!isDirectMessage && currentParticipants.length > 0" class="ch_participants float-right">
                <div class="participants_count" id="participantCountPopover" @click="showChannelParticipantsListModal" :title="currentParticipants.length + ' participants are in this channel, click to show details.'">
                  <span class="ic-group1"></span>
                  <span class="usr_count">{{currentParticipants.length}}</span>
                </div>
                <b-modal ref="channelParticipantsListModal" class="modal_popup modal-lg ch_usr_lst_popup" hide-header hide-footer centered size="xl">
                  <div class="row">
                    <div class="col-12 modal-header">
                      <div class="modal-title">
                        <div v-if="isDirectMessage">
                          <div class="title">
                            {{selectedPeerName}}
                          </div>
                        </div>
                        <div v-else-if="isGroupMessage">
                          <div class="title">
                            <div class="ic11-channel"></div>
                            <div class="title_txt">
                              {{selectedGroup.groupName}}
                            </div>
                          </div>
                        </div>
                        <div v-else class="title">
                          <template v-if="((channelType === 'ALL') || (channelType === 'ADVISOR'))">
                            <template v-if="advisorChannel && isAdvisorChannel">
                              <div class="ic11-channel"></div>
                              <div class="title_txt">Advisor's Channel</div>
                            </template>
                            <template v-else>
                              <template v-if="channel">
                                <div class="ic11-channel"></div>
                                <div class="title_txt">{{channel.channelName}}</div>
                              </template>
                            </template>
                          </template>
                          <template v-else>
                            <div class="ic11-channel"></div>
                            <div class="title">{{channel.channelName}}</div>
                          </template>
                        </div>
                      </div>
                      <div class="btn_container">
                        <button class="btn_close" aria-label="close" title="close" @click="closeChannelParticipantsListModal">
                        <span class="ic-close"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 usr_lst_container">
                      <div v-for="participant in currentParticipants" class="row">
                        <div class="ch_usr_row col-12">
                          <div class="user-avatar-default">
                            <span class="ic-user">
                            <span class="user-status"></span>
                            </span>
                          </div>
                          <div class="usr_name">{{participant.name}} <span class="ml-3" v-if="(userId !== participant.userUuid) && isUserOnline(participant.userUuid)"><i class="fas fa-dot-circle" style="font-size: 13px; color: #006400;"></i></span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </span>
            </div>

          </div>
          <template v-if="isChannelLoaded">
            <template v-if="channel">
              <div class="channel-mid-column">
                <div class="msg_row_section rich-text-editor-msg">
                  <div class="msg_section_inner" v-if="messages.length > 0" :class="{'rich-text-editor-msg-leave-group': isParticipantLeft}">
                    <div class="row" v-for="(newMessages, date, index) in groupByDate(messages)">
                      <div class="col-12">

                        <div class="msg_date_sep">
                          <span>{{formattedDate(date)}}</span>
                        </div>

                        <div class="chat-message" v-for="(message, index) in newMessages" :class="{'d-none': (isParticipantLeft && index > newMessages.findIndex((msg) => {return msg.uuid === 'left-' + userId}))}">
                          <div class="message-avatar-default">
                            <span class="ic-user"></span>
                          </div>
                          <div class="message-details">
                            <div class="msg_type"  v-if="message.type && message.type === 'Urgent Notification'">
                              <span class="job-tag tag_notification"> {{message.type}}</span>
                            </div>
                            <div class="msg_type"  v-if="message.type && message.type === 'Recommendation'">
                              <span class="job-tag tag_recommendation"> {{message.type}}</span>
                            </div>
                            <div class="message-author-name">
                              <div class="message-author">{{message.name}}</div>
                              <div class="message-time">{{get12HourTime(message.time)}}</div>
                              <template v-if="(message.uuid === userId)">
                                <b-nav-item-dropdown right class="more_option">
                                  <!-- Using button-content slot -->
                                  <template slot="button-content">
                                    <span class="ic9-iconMore-0005"></span>
                                  </template>
                                  <template v-if="!message.isFile">
                                    <b-dropdown-item @click="showEditMessageModal(message)">
                                      <!--
                                        <span class="icon-edit"></span>
                                        -->
                                      <span class="txt">edit</span>
                                    </b-dropdown-item>
                                  </template>
                                  <b-dropdown-item class="last_child" @click="showDeleteMessageModal(message)">
                                    <!--
                                      <span class="icon-bin"></span>
                                      -->
                                    <span class="txt">delete</span>
                                  </b-dropdown-item>
                                </b-nav-item-dropdown>
                              </template>
                            </div>
                            <div class="message">
                              <template v-if="message.isFile">
                                <div class="message-content">
                                  <a :href="message.text" target="_blank" style="color: #0645AD;">{{message.fileName}}</a>
                                </div>
                              </template>
                              <template v-else>
                                <div class="message-content float-left" v-html="message.text" @click="handlerShowImageInModal"></div>
                                <div v-if="message.edited" class="float-left ml-1"><small>(edited)</small></div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-message-form rich-text-editor-box" v-if="!isParticipantLeft" :class="canSendOtherTypes ? 'msg_type_selection_on' : ''">
                  <div class="ch_msg_type">
                    <b-dropdown no-caret v-if="canSendOtherTypes">
                      <template slot="button-content">
                        <span class="icon ic-channel" v-if="messageType == 'Message'"></span>
                        <span class="icon icon-bell" v-if="messageType == 'Urgent Notification'"></span>
                        <span class="icon icon-bullhorn" v-if="messageType == 'Recommendation'"></span>
                        <span class="icon-dropdown2"></span>
                      </template>
                      <b-dropdown-item @click="changeType('Recommendation')" :disabled="messageType === 'Recommendation'"><span class="icon icon-bullhorn"></span><span class="text">Recommendation</span></b-dropdown-item>
                      <b-dropdown-item @click="changeType('Urgent Notification')" :disabled="messageType === 'Urgent Notification'"><span class="icon icon-bell"></span><span class="text">Urgent Notification</span></b-dropdown-item>
                      <b-dropdown-item @click="changeType('Message')" :disabled="messageType === 'Message'"><span class="icon ic-channel"></span><span class="text">Message</span></b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <div class="field-section">
                    <div class="attachment_ic_container">
                      <input type="file" id="sectionFileUpload" ref="fileInput" class="file-attachment" @change="handlerFileUpload" />
                      <label for="sectionFileUpload" id="sectionFileUploadIcon" class="sec_file_upload">
                        <template v-if="isUploadingAttachment">
                          <span class="fa fa-spinner fa-pulse"></span>
                        </template>
                        <template v-else>
                          <span class="fa fa-paperclip attachment-icon" aria-hidden="true"></span>
                        </template>
                      </label>
                    </div>
                    <div class="expand_mce_tools" @click="showTextOptions">
                      Aa
                    </div>
                    <editor api-key="no-api-key"
                    v-model.trim="sendMessage"
                    :init="({
                    base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
                    selector: 'textarea',
                    menubar: false,
                    plugins: plugins,
                    toolbar: toolbar,
                    branding: false,
                    statusbar: false,
                    end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    @onKeyUp="handlerKeyUp"
                    @onKeyDown="handlerKeyDown"
                    @onBlur="handlerBlur"
                    id="sectionRichTextMessage">
                    </editor>
                    <div class="right-section rich-text-editor-btn">
                      <div class="send_btn_container">
                        <button type="submit" value="send" class="send-btn btn rich-text-editor-send-btn" id="sectionSendMessageButton" @click="send(true)">
                        <span class="ic11-send"></span>
                        </button>
                      </div>
                    </div>
                    <div class="btn_sec_separator"></div>
                  </div>
                </div>
                <template v-if="!isParticipantLeft">
                  <div class="user-typing-status">
                    <div v-if="typingStatus.length > 0">
                      <span>{{showTypingUsers}}</span>
                    </div>
                    <div v-if="sendMessage.length > 5">
                      <span class="mr-3"><small><b>Enter</b> to send</small></span>
                      <span><small><b>Shift + Enter</b> to add a new line</small></span>
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div class="row" style="margin: 10px 0 0 200px;">
                <h3>Channel was not created for this course section.</h3>
              </div>
            </template>
          </template>
        </div>
        <!-- == .ch_rgt_panel == -->
      </div>
      <!-- == .channel-content-section == -->
    </div>
    <!-- == .channel-section.channel-modal-popup == -->
    <!-- image viewer modal -->
    <div>
      <b-modal ref="imageViewerModal" @hidden="selectedImageSource = null" hide-footer size="xl">
        <img :src="selectedImageSource" class="w-100" />
      </b-modal>
    </div>
    <!-- edit message modal -->
    <div>
      <b-modal id="edit-message-popup" class="edit_msg_popup" ref="editMessageModal" :header-bg-variant="'discover-content-delete-modal'" title="Edit Message" size="xl" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div>
          <editor api-key="no-api-key" 
            v-model.trim="editMessage"
            :init="({
            base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
            selector: 'textarea',
            menubar: false,
            plugins: plugins,
            toolbar: toolbar,
            branding: false,
            statusbar: false
            })"
            id="editMessageRowId"
            @onInit="(event, editor) => {handlerInitEditMessage(event, editor)}"
            @onKeyUp="(event, editor) => {handlerKeyUpEditMessage(event, editor, selectedMessage)}">
          </editor>
        </div>
        <div slot="modal-footer" class="w-100">
          <span v-if="editMessage.length > 5">
          <span class="mr-3"><small><b>Enter</b> to send</small></span>
          <span><small><b>Shift + Enter</b> to add a new line</small></span>
          </span>
          <b-button @click="saveEditMessage(true, selectedMessage)" class="btn button-primary float-right mr-2">Save Changes</b-button>
          <b-link class="float-right mr-4 mt-1" @click="discardEditMessage">No, Discard Changes</b-link>
        </div>
      </b-modal>
    </div>
    <!-- delete message modal -->
    <div>
      <b-modal id="delete-message-popup" ref="deleteMessageModal" :header-bg-variant="'discover-content-delete-modal'" title="Delete Message" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center">
          <h6>Are you sure you want to delete this message? This cannot be undone.</h6>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteMessage" class="btn button-primary float-right mr-2">Delete Message</b-button>
          <b-link class="float-right mr-4 mt-1" @click="cancelDeleteMessage">No, Do not delete</b-link>
        </div>
      </b-modal>
    </div>
    <!-- leave group modal -->
    <div>
      <b-modal id="leave-group-popup" ref="leaveGroupModal" :header-bg-variant="'discover-content-delete-modal'" title="Leave Group" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center">
          <h6>Are you sure you want to leave <strong>{{leavingGroupName}}</strong> Group Channel? If you want to re-join you will have to contact your Instructor.</h6>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="leaveGroup" class="btn button-primary float-right mr-2">Ok, Leave Group</b-button>
          <b-link class="float-right mr-4 mt-1" @click="cancelLeaveGroupModal">No, Do not leave</b-link>
        </div>
      </b-modal>
    </div>
    <!-- create group modal -->
    <div>
      <b-modal id="create-group-popup" class="create_grp_ch modal-lg" ref="createGroupModal" hide-header no-close-on-backdrop no-close-on-esc centered>
        <div class="mb-2">
          <b-input-group style="padding: 0px 0 0 0;">
            <b-form-input v-model.trim="groupName" placeholder="type in group name" style="height: 20px;"/>
          </b-input-group>
        </div>
        <div class="usr_lst_container">
          <b-form-group>
            <b-form-checkbox-group plain stacked v-model="selectedParticipants" style="width: 100%;">
              <b-form-checkbox v-for="participant in sortedParticipants" :key="participant.userUuid" :value="participant" v-if="(userId !== participant.userUuid)">
                <div class="row">
                  <div class="col-1 user-avatar-default">
                    <span class="ic-user">
                    <span class="user-status"></span>
                    </span>
                  </div>
                  <div class="col-10 check-description">{{getDisplayName(participant)}}</div>
                </div>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <div slot="modal-footer" class="w-100">
          <div class="row">
            <div class="col-7 desc">
              Select at least 2 participants to create a study group. <br />You will be added to group by default.
            </div>
            <div class="col-5">
              <b-button @click="createGroup" class="btn button-primary float-right mr-1" aria-label="create" :disabled="(selectedParticipants.length < 3)">create</b-button>
              <b-button @click="cancelCreateGroup" class="btn button-primary float-right mr-1" aria-label="cancel">cancel</b-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- delete group confirm modal -->
    <div>
      <b-modal ref="deleteGroupConfirmModal" title="Please Confirm!" :header-bg-variant="'discover-content-delete-modal'" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center">
          <h6>Are you sure you want to delete this group?</h6>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteGroup" class="btn button-primary float-right mr-2"> yes </b-button>
          <b-button @click="cancelDeleteGroup" class="btn button-primary float-right mr-2"> no </b-button>
        </div>
      </b-modal>
    </div>
    <!-- create direct channel modal -->
    <div>
      <b-modal id="create-direct-channel-popup" class="modal_popup modal-lg ch_direct_create_popup" ref="createDirectChannelModal" :header-bg-variant="'discover-content-delete-modal'" hide-header-close no-close-on-backdrop no-close-on-esc centered size="xl">
        <div class="row">
          <div class="col-12 modal-header">
            <div class="modal-title">
              <div class="title">
                <div class="ic11-channel"></div>
                <div class="title_txt">Add To Direct Channel</div>
              </div>
            </div>
            <div class="btn_container">
              <button class="btn_close" aria-label="close" title="close" @click="cancelCreateDirectChannel">
              <span class="ic-close"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 search_bar_section">
            <input v-model="directChannelSearchTerm" placeholder="type to narrow list" class="search_fld">
            <template v-if="directChannelSearchTerm.length > 0">
              <b-btn class="btn_clear" aria-label="clear" title="clear" @click="directChannelSearchTerm = ''">
                <span class="ic-close"></span>
              </b-btn>
            </template>
          </div>
        </div>
        <div class="usr_lst_container">
          <b-form-group>
            <b-form-checkbox-group plain stacked v-model="selectedDirectChannelUsers" style="width: 100%;">
              <b-form-checkbox v-for="user in filteredDirectChannelUsers" :key="user.userUuid" :value="user" :disabled="isAlreadyAddedForDirectChannel(user.userUuid)">
                <div class="row">
                  <div class="col-1 user-avatar-default">
                    <span class="ic-user">
                    <span class="user-status"></span>
                    </span>
                  </div>
                  <div class="col-10 check-description">{{getDisplayName(user)}}</div>
                </div>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <div slot="modal-footer" class="w-100">
          <div>
            <b-button @click="createDirectChannel" class="btn button-primary float-right mr-1" aria-label="add" :disabled="(selectedDirectChannelUsers.length === 0)">add</b-button>
            <b-button @click="cancelCreateDirectChannel" class="btn button-primary float-right mr-1" aria-label="cancel">cancel</b-button>
          </div>
        </div>
      </b-modal>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

    <bad-words-prompt ref="badWordsAlert" @sendMaskedBadWords="sendMaskedBadWords" :editorInstanceId="editorInstanceId"></bad-words-prompt>

  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { mapState, mapActions } from 'vuex'
  import Editor from '@tinymce/tinymce-vue'
  import { db, storage } from '../../../firebase'
  import { PACKAGE } from '../../../package_constants'
  import BadWordsPrompt from './BadWordsPrompt'

  export default {
    name: 'channel',
    props: ['uuid', 'entityId', 'selectedCurrentChannel', 'channelType', 'isLoadingOnWidget'],
    components: {
      Editor,
      BadWordsPrompt
    },
    data: (vm) => {
      return {
        showChannelMenu: false,
        channel: null,
        courses: {},
        messages: [],
        onlineUsers: [],
        typingStatus: [],
        sendMessage: '',
        editMessage: '',
        groupName: '',
        messageType: 'Message',
        selectedPeerName: null,
        currentChannel: vm.selectedCurrentChannel || vm.uuid,
        isChannelLoaded: false,
        selectedUserId: '',
        selectedGroup: null,
        selectedParticipants: [],
        userId: '',
        userName: '',
        userRole: 'Student',
        plugins: 'lists  autolink charmap code hr link textcolor',
        toolbar: 'bold italic strikethrough | bullist numlist | forecolor backcolor | removeformat link unlink',
        isUploadingAttachment: false,
        isChannelRenameClicked: false,
        selectedRenameElemId: '',
        channelName: '',
        unreadList: [],
        selectedImageSource: null,
        selectedGroupToDelete: null,
        isEditMessageClicked: false,
        isGroupMessageSelected: false,
        selectedMessage: '',
        editorInstanceId: '',
        groupChannels: [],
        advisorChannel: null,
        advisorChannels: [],
        selectedText: '',
        leavingGroupName: '',
        typingTimeout: null,
        isTypingStatusCleared: true,
        currentParticipants: [],
        directChannelParticipants: [],
        searchTerm: '',
        directChannelUsers: [],
        directChannelSearchTerm: '',
        selectedDirectChannelUsers: [],
        isGroupChannelVisible: true,
        isDirectChannelVisible: false
      }
    },
    created () {
      this.setUserData()
      this.$watch('currentChannel', (selectedChannelId) => {
        if (selectedChannelId) {
          let dbRef = db.ref('channels/' + selectedChannelId + '/Messages')
          if (this.isDirectMessage) {
            dbRef = db.ref('Direct/' + selectedChannelId + '/Messages')
          }
          this.$bindAsArray('messages', dbRef)
          this.$bindAsArray('typingStatus', db.ref('Typing/' + selectedChannelId))
        }
        this.$bindAsArray('onlineUsers', db.ref('Online'))
        this.$bindAsArray('unreadList', db.ref('Unread/' + this.userId))
      }, {
        immediate: true
      })
      this.$watch('channelType', (value) => {
        if (value === 'ALL') {
          this.selectedText = 'All Channels'
          this.loadSelectedChannelType(value)
        } else if (value === 'ADVISOR') {
          this.selectedText = 'Advisor\'s Channel'
          this.loadSelectedChannelType(value)
        } else if (value === 'COURSE') {
          this.selectedText = this.course.title + ' Course Channels'
        }
      }, {
        immediate: true
      })
    },
    async beforeMount () {
      this.courses = await this.loadCoursesWithChannel()
      if (this.isCourseChannel) {
        let course = await this.loadCourseDetail(this.uuid)
        this.selectedText = course.title + ' Course Channels'
      }
      let courseId = this.isCourseChannel ? this.uuid : 'NONE'
      await this.populateDirectChannelUsers(courseId)
      await this.populateDirectChannelPeerMap()
    },
    async mounted () {
      if (!this.channelType) {
        await this.loadAllChannels()
      }
      await this.filterAdvisorAndGroupChannels()
      await this.populateDirectChannelParticipants()
      if (this.isCourseChannel) {
        await this.loadCourseChannel()
      } else {
        this.showLoader()
        let type = this.channelType || 'ALL'
        this.loadSelectedChannelType(type)
        this.updateOnlinePresence(true)
        this.isChannelLoaded = true
        setTimeout(() => {
          this.scrollToLastMessage()
          this.hideLoader()
        }, 500)
      }
    },
    watch: {
      messages () {
        this.scrollToLastMessage()
        setTimeout(() => {
          this.markRead()
        }, 1000)
      },
      unreadList (newUnreadList) {
        if (newUnreadList.length > 0) {
          this.filterAdvisorAndGroupChannels()
          if (this.channel && this.channel.studyGroups) {
            let cloned = _.cloneDeep(this.channel.studyGroups)
            this.channel.studyGroups = []
            this.channel.studyGroups = cloned
          }
        }
      }
    },
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj,
        'course': state => state.dashboard.course,
        'myChannels': state => state.dashboard.channels,
        'customBadWords': state => state.dashboard.customBadWords,
        'enabledFeatures': state => state.dashboard.enabledFeatures,
        'channelUnreadCount': state => state.dashboard.channelUnreadCount
      }),
      canSendOtherTypes () {
        if (this.userRole !== 'Student' && this.userRole !== 'Prospective Student' && this.userRole !== 'Admitted Student') {
          return true
        }
        return false
      },
      firstName () {
        return this.userName.split(' ')[0]
      },
      isCourseChannel () {
        if (!this.channelType && (this.uuid !== this.userId)) {
          this.entityId = this.uuid
        }
        return (this.uuid === this.entityId) && (this.uuid !== this.userId)
      },
      isAdvisorChannel () {
        return (this.advisorChannel && (this.advisorChannel.externalId === this.currentChannel))
      },
      isDirectMessage () {
        return !this.isGroupMessageSelected && (this.channel && (this.channel.externalId !== this.currentChannel))
      },
      isGroupMessage () {
        return this.isGroupMessageSelected && (this.channel && (this.channel.externalId !== this.currentChannel))
      },
      sortedParticipants () {
        let participants = (this.channel) ? this.channel.participants : []
        let sortedParticipants = _.filter(participants, (p) => {
          return (this.userId === p.userUuid)
        })
        participants.forEach(p => {
          if (this.userId !== p.userUuid) {
            sortedParticipants.push(p)
          }
        })
        return sortedParticipants
      },
      showTypingUsers () {
        let names = ''
        let typingUsers = []
        let participants = (this.channel) ? this.channel.participants : []
        participants.forEach(p => {
          if (this.userId !== p.userUuid) {
            let user = _.find(this.typingStatus, (item) => {
              return (p.userUuid === item.uuid)
            })
            if (user) {
              typingUsers.push(user.name)
            }
          }
        })
        if (typingUsers.length > 0) {
          let text = (typingUsers.length > 1) ? ' are typing' : ' is typing'
          names = typingUsers.join(', ').concat(text)
        }
        return names
      },
      isParticipantLeft () {
        if (this.isDirectMessage) {
          return false
        } else if (this.isGroupMessage) {
          return _.find(this.selectedGroup.leftParticipantIds, (participantId) => {
            return (this.userId === participantId)
          })
        } else {
          return _.find(this.channel.leftParticipants, (p) => {
            return (this.userId === p.userUuid)
          })
        }
      },
      isAdminLogin () {
        let role = this.userObj.roles[0].role
        return (role === 'Instructor & Admin')
      },
      filteredGroupChannels () {
        let items = this.groupChannels.filter(item => {
          let count = this.channelUnreadCount[item.externalId]
          if (count > 0) {
            item.hasUnread = true
          } else {
            item.hasUnread = false
          }
          return item.channelName.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
        return items.sort((a, b) => Number(b.hasUnread) - Number(a.hasUnread))
      },
      filteredStudyGroups () {
        if (!this.channel.studyGroups) {
          return []
        }
        let items = this.channel.studyGroups.filter(item => {
          let count = this.channelUnreadCount[item.groupId]
          if (count > 0) {
            item.hasUnread = true
          } else {
            item.hasUnread = false
          }
          return item.groupName.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
        return items.sort((a, b) => Number(b.hasUnread) - Number(a.hasUnread))
      },
      filteredChannelName () {
        return this.channel.channelName.toLowerCase().includes(this.searchTerm.toLowerCase())
      },
      filteredDirectChannelParticipants () {
        return this.directChannelParticipants.filter(item => {
          return item.displayName.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
      },
      filteredDirectChannelUsers () {
        return this.directChannelUsers.filter(item => {
          return this.getDisplayName(item).toLowerCase().includes(this.directChannelSearchTerm.toLowerCase())
        })
      },
      showAddDirectChannel () {
        if (this.channelType !== 'ADVISOR') {
          let enabledOnAll = false
          let enabledOnCourse = false
          let channelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNELS_FEATURE_ID]
          if (channelFeature) {
            let flags = channelFeature.flags
            flags.forEach(flag => {
              if (flag.title === 'showAddDirectChannelOnAll') {
                enabledOnAll = flag.enabled
              } else if (flag.title === 'showAddDirectChannelOnCourse') {
                enabledOnCourse = flag.enabled
              }
            })
          }
          if (this.channelType === 'ALL') {
            return enabledOnAll
          } else if (this.channelType === 'COURSE') {
            return enabledOnCourse
          }
        }
        return false
      },
      isShowMoreLink () {
        let length = 0
        if (this.channelType === 'ALL') {
          let filtered = this.groupChannels.filter(item => {
            return item.channelName.toLowerCase().includes(this.searchTerm.toLowerCase())
          })
          length = filtered.length
        } else {
          if (this.channel.studyGroups) {
            length = 1
            let filtered = this.channel.studyGroups.filter(item => {
              return item.groupName.toLowerCase().includes(this.searchTerm.toLowerCase())
            })
            filtered.forEach(studyGroup => {
              if (studyGroup.participantIds.includes(this.userId)) {
                ++length
              }
            })
          }
        }
        return length > 5
      }
    },
    beforeRouteLeave (to, from, next) {
      this.updateOnlinePresence(false)
      next()
    },
    methods: {
      ...mapActions([
        'loadAllChannels',
        'loadCoursesWithChannel',
        'loadCourseSectionChannel',
        'loadCourseDetail',
        'loadAttachmentUpload',
        'loadCreateChannel',
        'loadDirectChannelUsers',
        'loadDirectChannelPeerMap',
        'loadAddToDirectChannelPeerMap',
        'loadUpdateDirectChannelPeerMap',
        'loadCreateStudyGroup',
        'loadDeleteStudyGroup',
        'loadParticipantDisplayNames',
        'updateUnread'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      setUserData () {
        this.userId = this.userObj.uuid
        this.userName = this.userObj.firstName + ' ' + this.userObj.lastName
        this.userRole = this.userObj.roles[0].role
      },
      groupByDate (messages) {
        _.forEach(messages, (message) => {
          let dateAndTime = message.date.split(' ')
          message.date = dateAndTime[0]
          if (!message.time) {
            message.time = dateAndTime[1]
          }
        })
        return _.groupBy(messages, 'date')
      },
      get12HourTime (value) {
        if (value.indexOf('am') !== -1 || value.indexOf('pm') !== -1) {
          return value
        }
        let hrmn = value.split(':')
        let hr = hrmn[0]
        let mn = hrmn[1]
        let ampm = hr >= 12 ? 'pm' : 'am'
        hr = hr % 12
        hr = hr ? hr : 12
        let time = hr + ':' + mn + ' ' + ampm
        return time
      },
      formattedDate (value) {
        let date = moment(new Date(value).toISOString())
        if (date.isSame(moment(), 'day')) {
          return 'Today'
        } else if (date.isSame(moment().subtract(1, 'd'), 'day')) {
          return 'Yesterday'
        } else if (date.isSame(moment(), 'year')) {
          return date.format('ddd, MMM DD')
        } else {
          return date.format('MMM DD, YYYY')
        }
      },
      scrollToLastMessage () {
        setTimeout(() => {
          let scrollTo = 0
          let container = $('.msg_row_section')
          let children = $('.msg_section_inner').children()
          for (let i = 0; i < children.length; i++) {
            let elem = children.eq(i)
            scrollTo += ($(elem).innerHeight() + 15)
          }
          container.scrollTop(scrollTo)
        }, 100)
      },
      showChannelListPanel () {
        let channelListPanel = $('.left-channel-panel')
        channelListPanel.addClass('show_lft_pan')
        channelListPanel.removeClass('hide_lft_pan')
      },
      hideChannelListPanel () {
        let channelListPanel = $('.left-channel-panel')
        channelListPanel.addClass('hide_lft_pan')
        channelListPanel.removeClass('show_lft_pan')
      },
      isUserOnline (userId) {
        return _.find(this.onlineUsers, (item) => {
          return (userId === item.uuid)
        })
      },
      updateOnlinePresence (isOnline) {
        if (this.currentChannel) {
          let dbRef = db.ref('Online')
          if (isOnline) {
            dbRef.push({
              uuid: this.userId
            })
          } else {
            dbRef.orderByChild('uuid').equalTo(this.userId).once('value').then((snapshot) => {
              snapshot.forEach((childSnapshot) => {
                dbRef.child(childSnapshot.key).remove()
              })
            })
          }
        }
      },
      updateTypingStatus (isTyping) {
        if (this.currentChannel) {
          let dbRef = db.ref('Typing/' + this.currentChannel)
          if (isTyping) {
            this.isTypingStatusCleared = false
            dbRef.push({
              uuid: this.userId,
              name: this.firstName
            })
          } else {
            this.isTypingStatusCleared = true
            dbRef.orderByChild('uuid').equalTo(this.userId).once('value').then((snapshot) => {
              snapshot.forEach((childSnapshot) => {
                dbRef.child(childSnapshot.key).remove()
              })
            })
          }
        }
      },
      channelMessageUnreadCount (channel) {
        let count = 0
        let data = _.find(this.unreadList, (item) => {
          return (item.channelMessage && (item.channelId === channel.externalId))
        })
        if (data) {
          count = data.unreadCount
        }
        let dbRef = db.ref('channels/' + channel.externalId + '/unread/' + this.userId)
        dbRef.on('value', (snapshot) => {
          count += snapshot.numChildren()
        })
        return count
      },
      directMessageUnreadCount (userId) {
        let data = _.find(this.unreadList, (item) => {
          return ((userId === item.uuid) && item.directMessage)
        })
        if (data) {
          return data.unreadCount
        }
        return 0
      },
      groupMessageUnreadCount (group) {
        let value = 'group_' + group.groupId + '_' + this.userId
        let data = _.find(this.unreadList, (item) => {
          return ((value === item.type_groupId_uuid) && item.groupMessage)
        })
        if (data) {
          return data.unreadCount
        }
        return 0
      },
      markRead () {
        this.markReadForUser()
        // this.markReadDeprecated()
      },
      markReadForUser () {
        let userId = this.userObj.uuid
        let dbRef = db.ref('Unread/' + userId)
        if (this.currentChannel) {
          dbRef.child(this.currentChannel).remove()
          this.updateUnread({channelId: this.currentChannel, unread: 0})
        }
      },
      async markReadDeprecated () {
        let userId = this.userObj.uuid
        let dbRef = db.ref('channels/' + this.uuid + '/unread/' + userId)
        if (this.isDirectMessage) {
          dbRef.orderByChild('uuid').equalTo(this.selectedUserId).once('value').then((snapshot) => {
            snapshot.forEach((childSnapshot) => {
              dbRef.child(childSnapshot.key).remove()
            })
          })
        } else {
          if (this.isGroupMessage) {
            let value = 'group_' + this.selectedGroup.groupId + '_' + userId
            dbRef.orderByChild('type_groupId_uuid').equalTo(value).once('value').then((snapshot) => {
              snapshot.forEach((childSnapshot) => {
                dbRef.child(childSnapshot.key).remove()
              })
            })
          } else {
            dbRef.orderByChild('channelMessage').equalTo(true).once('value').then((snapshot) => {
              snapshot.forEach((childSnapshot) => {
                dbRef.child(childSnapshot.key).remove()
              })
            })
          }
        }
        // await db.ref('channels/' + this.uuid + '/Unread/' + userId).remove()
        await db.ref('channels/' + this.currentChannel + '/unread/' + userId).remove()
      },
      updateAllUnread () {
        this.updateAllUnreadForUser()
        // this.updateAllUnreadDeprecated()
      },
      updateAllUnreadDeprecated () {
        let key = this.currentChannel
        if (key) {
          if (this.isDirectMessage) {
            db.ref('channels/' + this.uuid + '/unread/' + this.selectedUserId).push({
              channelId: key,
              uuid: this.userId,
              directMessage: true
            })
          } else if (this.isGroupMessage) {
            this.selectedGroup.participantIds.forEach((paricipantId, i) => {
              if ((this.userId !== paricipantId) && !this.selectedGroup.leftParticipantIds.includes(paricipantId)) {
                db.ref('channels/' + this.uuid + '/unread/' + paricipantId).push({
                  channelId: key,
                  uuid: paricipantId,
                  type_groupId_uuid: 'group_' + this.selectedGroup.groupId + '_' + paricipantId,
                  groupMessage: true
                })
              }
            })
          } else {
            this.channel.participants.forEach((item, i) => {
              let isLeft = _.find(this.channel.leftParticipants, (p) => {
                return (item.userUuid === p.userUuid)
              })
              if ((this.userId !== item.userUuid) && !isLeft) {
                db.ref('channels/' + this.uuid + '/unread/' + item.userUuid).push({
                  channelId: key,
                  uuid: item.userUuid,
                  channelMessage: true
                })
              }
            })
          }
        }
      },
      updateAllUnreadForUser () {
        let key = this.currentChannel
        if (key) {
          let messageId
          this.$firebaseRefs.messages.limitToLast(1).once('child_added', (child) => {
            messageId = child.key
          })
          if (this.isDirectMessage) {
            let lastItem = {unreadCount: 0, lastUnreadMessageId: messageId}
            let dbRef = db.ref('Unread/' + this.selectedUserId)
            dbRef.child(key).on('value', (snapshot) => {
              let child = snapshot.val()
              if (child !== null) {
                lastItem.unreadCount = child.unreadCount
                lastItem.lastUnreadMessageId = child.lastUnreadMessageId
              }
            })
            let unreadCount = lastItem.unreadCount + 1
            dbRef.child(key).set({
              channelId: key,
              uuid: this.userId,
              directMessage: true,
              unreadCount: unreadCount,
              lastUnreadMessageId: lastItem.lastUnreadMessageId
            })
            this.updateUnread({channelId: key, unread: unreadCount})
          } else if (this.isGroupMessage) {
            this.selectedGroup.participantIds.forEach((paricipantId, i) => {
              if ((this.userId !== paricipantId) && !this.selectedGroup.leftParticipantIds.includes(paricipantId)) {
                let lastItem = {unreadCount: 0, lastUnreadMessageId: messageId}
                let dbRef = db.ref('Unread/' + paricipantId)
                dbRef.child(key).on('value', (snapshot) => {
                  let child = snapshot.val()
                  if (child !== null) {
                    lastItem.unreadCount = child.unreadCount
                    lastItem.lastUnreadMessageId = child.lastUnreadMessageId
                  }
                })
                let unreadCount = lastItem.unreadCount + 1
                dbRef.child(key).set({
                  channelId: key,
                  groupMessage: true,
                  uuid: paricipantId,
                  unreadCount: unreadCount,
                  lastUnreadMessageId: lastItem.lastUnreadMessageId,
                  type_groupId_uuid: 'group_' + this.selectedGroup.groupId + '_' + paricipantId
                })
                this.updateUnread({channelId: key, unread: unreadCount})
              }
            })
          } else {
            this.channel.participants.forEach((item, i) => {
              let isLeft = _.find(this.channel.leftParticipants, (p) => {
                return (item.userUuid === p.userUuid)
              })
              if ((this.userId !== item.userUuid) && !isLeft) {
                let lastItem = {unreadCount: 0, lastUnreadMessageId: messageId}
                let dbRef = db.ref('Unread/' + item.userUuid)
                dbRef.child(key).on('value', (snapshot) => {
                  let child = snapshot.val()
                  if (child !== null) {
                    lastItem.unreadCount = child.unreadCount
                    lastItem.lastUnreadMessageId = child.lastUnreadMessageId
                  }
                })
                let unreadCount = lastItem.unreadCount + 1
                dbRef.child(key).set({
                  channelId: key,
                  uuid: item.userUuid,
                  channelMessage: true,
                  unreadCount: unreadCount,
                  lastUnreadMessageId: lastItem.lastUnreadMessageId
                })
                this.updateUnread({channelId: key, unread: unreadCount})
              }
            })
          }
        }
      },
      async populateCurrentParticipants (isGroup) {
        this.currentParticipants = []
        if (isGroup) {
          let participantIds = _.difference(this.selectedGroup.participantIds, this.selectedGroup.leftParticipantIds)
          let uuidDisplayNameMap = await this.loadParticipantDisplayNames(participantIds)
          for (let key in uuidDisplayNameMap) {
            let name = uuidDisplayNameMap[key]
            if (key === this.userId) {
              name += ' (you)'
            }
            this.currentParticipants.push({userUuid: key, name: name})
          }
        } else {
          let participants = _.difference(this.channel.participants, this.channel.leftParticipants)
          let sortedParticipants = _.sortBy(participants, 'firstName')
          sortedParticipants.forEach(p => {
            let userUuid = p.userUuid
            let name = p.firstName + ' ' + p.lastName
            if (userUuid === this.userId) {
              name += ' (you)'
            }
            this.currentParticipants.push({userUuid: userUuid, name: name})
          })
        }
      },
      async loadCourseChannel () {
        this.showLoader()
        this.loadCourseSectionChannel(this.uuid).then(resp => {
          this.channel = resp
          this.updateOnlinePresence(true)
          this.isChannelLoaded = true
          this.hideLoader()
          this.scrollToLastMessage()
          this.populateCurrentParticipants(false)
        })
      },
      async loadSelectedCourseChannel (courseId) {
        await this.loadCourseDetail(courseId)
        this.channel = await this.loadCourseSectionChannel(courseId)
        this.$router.push({name: 'courseSectionChannel', params: {uuid: courseId, entityId: courseId, channelType: 'COURSE'}})
        this.entityId = courseId
        this.channelType = 'COURSE'
        this.populateCurrentParticipants(false)
        this.resetPreviousSelectedChannel(courseId)
        await this.populateDirectChannelUsers(courseId)
        this.selectedText = this.course.title + ' Course Channels'
      },
      loadSelectedChannelType (type) {
        if (this.channelType !== type) {
          this.channelType = type
          if (type === 'ALL') {
            this.populateDirectChannelUsers('NONE')
            this.$router.push({name: 'courseSectionChannel', params: {uuid: this.userId, channelType: 'ALL'}})
          } else {
            this.selectedCurrentChannel = null
            this.$router.push({name: 'courseSectionChannel', params: {uuid: this.userId, channelType: 'ADVISOR'}})
          }
        }
        if (this.selectedCurrentChannel) {
          this.channel = _.find(this.myChannels, (myChannel) => {
            return (this.selectedCurrentChannel === myChannel.externalId)
          })
        } else {
          this.entityId = null
          if (this.advisorChannel) {
            this.channel = this.advisorChannel
          }
          if (!this.channel) {
            if (this.groupChannels && this.groupChannels.length > 0) {
              this.channel = this.groupChannels[0]
            }
          }
        }
        if (this.channel) {
          this.populateCurrentParticipants(false)
          let type = this.advisorChannel ? 'advisor-' : 'section-'
          setTimeout(() => {
            if (this.selectedCurrentChannel) {
              this.filterAdvisorAndGroupChannels()
            }
            // this.scrollSelectedChannel(type + this.channel.uuid)
          }, 1000)
        }
        this.resetPreviousSelectedChannel((this.channel ? this.channel.externalId : null))
        this.showChannelMenu = false
      },
      getDisplayName (participant) {
        return participant.firstName + ' ' + participant.lastName
      },
      showLeaveGroupModal () {
        this.leavingGroupName = this.isAdvisorChannel ? 'Advisor\'s Channel' : this.channel.channelName
        if (this.isGroupMessage) {
          this.leavingGroupName = this.selectedGroup.groupName
        }
        this.$refs.leaveGroupModal.show()
      },
      cancelLeaveGroupModal () {
        this.leavingGroupName = ''
        this.$refs.leaveGroupModal.hide()
      },
      async leaveGroup () {
        if (this.isGroupMessage) {
          _.forEach(this.channel.studyGroups, (group) => {
            if (this.selectedGroup.groupId === group.groupId) {
              let removedParticipantId = _.find(group.participantIds, (participantId) => {
                return (this.userId === participantId)
              })
              group.leftParticipantIds.push(removedParticipantId)
              return false
            }
          })
        } else {
          _.forEach(this.channel.participants, (participant) => {
            if (this.userId === participant.userUuid) {
              this.channel.leftParticipants.push(participant)
              return false
            }
          })
        }
        if (!this.channel.title) {
          this.channel.title = this.channel.channelName
        }
        let resp = await this.loadCreateChannel({channel: this.channel})
        if (resp) {
          let text = 'left #' + this.leavingGroupName
          this.sendGroupLeftMessage(text)
          this.cancelLeaveGroupModal()
          await this.loadAllChannels()
          this.filterAdvisorAndGroupChannels()
        }
      },
      sendGroupLeftMessage (text) {
        let date = new Date()
        let dd = date.getDate()
        let mm = date.getMonth() + 1
        let yyyy = date.getFullYear()
        let hr = date.getHours()
        let mn = date.getMinutes()
        if (mn < 10) {
          mn = '0' + mn
        }
        const message = {
          name: this.userName,
          role: this.userRole,
          uuid: 'left-' + this.userId,
          text: text,
          date: mm + '/' + dd + '/' + yyyy + ' ' + hr + ':' + mn,
          type: 'Message'
        }
        this.$firebaseRefs.messages.push(message)
      },
      scrollSelectedChannel (elemId) {
        if (elemId) {
          let container = $('.grp_ch_list .card')
          let scrollTo = $('#' + elemId)
          container.scrollTop(
            scrollTo.offset().top - container.offset().top - 100 + container.scrollTop()
          )
        }
      },
      loadChannelMessage (selectedChannel, elemId) {
        if (this.isChannelRenameClicked) {
          return
        }
        this.channel = selectedChannel
        this.populateCurrentParticipants(false)
        this.resetPreviousSelectedChannel(selectedChannel.externalId)
        this.showChannelMenu = false
        if (selectedChannel.hasUnread) {
          this.filterAdvisorAndGroupChannels()
          /*
          setTimeout(() => {
            this.scrollSelectedChannel(elemId)
          }, 2000)
          */
        }
      },
      async loadOneToOneMessage (participant) {
        let participantId = participant.userUuid
        if ((this.userId === participantId) || (this.selectedUserId === participantId)) {
          return
        }
        this.selectedGroup = null
        this.isGroupMessageSelected = false
        this.selectedUserId = participantId
        this.selectedPeerName = participant.displayName
        this.currentChannel = this.userObj.directChannelPeerMap[participantId]
        this.showChannelMenu = false
      },
      resetPreviousSelectedChannel (courseId) {
        $('.delete-group-icon').css('color', '#157099')
        this.selectedUserId = ''
        this.selectedGroup = null
        this.currentChannel = courseId
        this.isGroupMessageSelected = false
      },
      loadGroupMessage (group) {
        this.selectedUserId = ''
        this.selectedGroup = group
        this.isGroupMessageSelected = true
        this.currentChannel = group.groupId
        this.populateCurrentParticipants(true)
        this.showChannelMenu = false
        $('.delete-group-icon').css('color', '#157099')
        $('#' + this.currentChannel).css('color', '#865286')
      },
      clickChannelNameEdit (channel, elemId) {
        this.selectedRenameElemId = elemId
        this.channelName = channel.channelName
        this.isChannelRenameClicked = true
      },
      async updateChannelName (channel) {
        channel.title = channel.channelName = this.channelName
        await this.loadCreateChannel({channel: channel})
        this.cancelUpdateChannelName()
        await this.loadAllChannels()
        this.filterAdvisorAndGroupChannels()
      },
      cancelUpdateChannelName () {
        this.channelName = ''
        this.selectedRenameElemId = ''
        this.isChannelRenameClicked = false
      },
      isAdminUserOrParticipantOfChannel (participants) {
        if (this.isAdminLogin) {
          return true
        }
        return _.find(participants, (p) => {
          return (this.userId === p.userUuid)
        })
      },
      async filterAdvisorAndGroupChannels () {
        if (this.myChannels.length === 0) {
          await this.loadAllChannels()
        }
        this.advisorChannels = _.filter(this.myChannels, (myChannel) => {
          return (myChannel.entityId.indexOf('-Advisors') !== -1) && (myChannel.creatorId === this.userId) && this.isAdminUserOrParticipantOfChannel(myChannel.participants)
        })
        if (this.advisorChannels.length > 0) {
          this.advisorChannel = this.advisorChannels[0]
          let remainingChannels = _.difference(this.myChannels, [this.advisorChannel])
          this.groupChannels = _.filter(remainingChannels, (myChannel) => {
            return (myChannel.participants && myChannel.participants.length > 0)
          })
        } else {
          this.groupChannels = _.filter(this.myChannels, (myChannel) => {
            return (myChannel.participants && myChannel.participants.length > 0) && this.isAdminUserOrParticipantOfChannel(myChannel.participants)
          })
        }
      },
      showAddGroupModal () {
        this.groupName = ''
        this.selectedParticipants = []
        let participant = _.find(this.channel.participants, (p) => {
          return (this.userId === p.userUuid)
        })
        this.selectedParticipants.push(participant)
        this.$refs.createGroupModal.show()
      },
      createGroup () {
        this.showLoader()
        let groupName = ''
        let participantIds = []
        this.selectedParticipants.forEach((participant, i) => {
          if (this.groupName.length === 0) {
            if (groupName.length > 0) {
              groupName += ', '
            }
            groupName += participant.firstName
          } else {
            groupName = this.groupName
          }
          participantIds.push(participant.userUuid)
        })
        let data = {
          groupName: groupName,
          createdById: this.userId,
          createdByName: this.userName,
          participantIds: participantIds
        }
        this.loadCreateStudyGroup({channelId: this.channel.uuid, data: data}).then(resp => {
          this.channel = resp
          this.selectedGroup = resp.selectedGroup
          this.currentChannel = resp.selectedGroup.groupId
          this.loadGroupMessage(this.selectedGroup)
          this.cancelCreateGroup()
        })
        setTimeout(() => {
          this.hideLoader()
        }, 250)
      },
      cancelCreateGroup () {
        this.selectedParticipants = []
        this.$refs.createGroupModal.hide()
      },
      showDeleteGroupConfirmModal (group) {
        this.selectedGroupToDelete = group
        this.$refs.deleteGroupConfirmModal.show()
      },
      deleteGroup () {
        let groupId = this.selectedGroupToDelete.groupId
        let participantIds = this.selectedGroupToDelete.participantIds
        this.loadDeleteStudyGroup({channelId: this.channel.uuid, groupId: groupId}).then(resp => {
          this.channel = resp
          this.cancelDeleteGroup()
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully deleted the group'
          })
          participantIds.forEach((paricipantId, i) => {
            let dbRef = db.ref('Unread/' + paricipantId)
            dbRef.child(groupId).remove()
          })
        })
      },
      cancelDeleteGroup () {
        this.selectedGroupToDelete = null
        this.$refs.deleteGroupConfirmModal.hide()
      },
      preventEnterKeyEvent (container, ed) {
        $(container).keydown((e) => {
          const keyPressed = e.keyCode || e.which
          if ((keyPressed === 13) && !e.shiftKey) {
            let content = ed.getContent().replace(/<p>&nbsp;<\/p>/g, '')
            ed.setContent(content)
            ed.selection.select(ed.getBody(), true)
            ed.selection.collapse(false)
            return false
          }
        })
      },
      handlerInit (ev, editor) {
        $('#sectionRichTextMessage_ifr').width('calc(100% - 60px)')
        $('#sectionRichTextMessage_ifr').height('72px')
        $('.field-section').css('visibility', 'visible')
        let container = $('#sectionRichTextMessage_ifr')[0].contentWindow.document.body
        this.preventEnterKeyEvent(container, editor)
        setTimeout(() => {
          $('.mce-notification-warning').addClass('d-none')
        }, 300)
      },
      handlerKeyUp (ev, editor) {
        const keyPressed = ev.keyCode || ev.which
        if (((keyPressed === 13) && !ev.shiftKey) || ((keyPressed === 17) && (ev.target.innerHTML.indexOf('<img') !== -1))) {
          let isBadWordsNotAllowed = (keyPressed === 13) || (ev.target.innerHTML.indexOf('<img') === -1)
          this.send(isBadWordsNotAllowed)
        }
      },
      handlerKeyDown (ev, editor) {
        if (this.isTypingStatusCleared) {
          this.updateTypingStatus(true)
        }
        if (this.typingTimeout) {
          clearTimeout(this.typingTimeout)
        }
        this.typingTimeout = setTimeout(() => {
          this.updateTypingStatus(false)
        }, 750)
      },
      handlerBlur (ev, editor) {
        this.updateTypingStatus(false)
        clearTimeout(this.typingTimeout)
      },
      handlerInitEditMessage (ev, editor) {
        let elemId = '#editMessageRowId_ifr'
        $(elemId).height('100px')
        let container = $(elemId)[0].contentWindow.document.body
        this.preventEnterKeyEvent(container, editor)
      },
      handlerKeyUpEditMessage (ev, editor, message) {
        if ((ev.keyCode === 13) && !ev.shiftKey) {
          this.saveEditMessage(true, message)
        }
      },
      handlerShowImageInModal (ev) {
        this.selectedImageSource = null
        if (ev.target.matches('.open-img-modal')) {
          this.selectedImageSource = ev.target.currentSrc
          this.$refs['imageViewerModal'].show()
        }
      },
      closeImageViewerModal () {
        this.$refs['imageViewerModal'].hide()
      },
      showChannelParticipantsListModal () {
        this.$refs['channelParticipantsListModal'].show()
      },
      closeChannelParticipantsListModal () {
        this.$refs['channelParticipantsListModal'].hide()
      },
      handlerFileUpload (ev) {
        let files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.isUploadingAttachment = true
        let fileToBeUpload = files[0]
        let storageRef = storage.ref('files/' + this.userId)
        let spaceRef = storageRef.child(fileToBeUpload.name)
        spaceRef.put(fileToBeUpload).then((snapshot) => {
          snapshot.ref.getDownloadURL().then((downloadURL) => {
            let data = {
              'longDynamicLink': 'https://pragyasystems.page.link/?link=' + encodeURI(downloadURL),
              'suffix': {
                'option': 'UNGUESSABLE'
              }
            }
            this.loadAttachmentUpload(data).then(result => {
              let uploadedFileLink = result.shortLink
              this.sendUploadedFile(fileToBeUpload.name, uploadedFileLink)
              this.clearFilePath()
            })
          })
        })
      },
      clearFilePath () {
        const input = this.$refs.fileInput
        input.type = 'text'
        input.type = 'file'
        this.isUploadingAttachment = false
      },
      sendMaskedBadWords () {
        if (this.isEditMessageClicked) {
          this.saveEditMessage(false, this.selectedMessage)
        } else {
          this.send(false)
        }
      },
      async send (isBadWordsNotAllowed) {
        if (this.sendMessage.length > 0) {
          this.editorInstanceId = 'sectionRichTextMessage_ifr'
          let isNotAllowed = this.$refs.badWordsAlert.showPrompt(this.sendMessage, isBadWordsNotAllowed)
          if (!isNotAllowed) {
            this.sendMessage = this.sendMessage.replaceAll(/<p style=.*>&nbsp;<\/p>/g, '').replaceAll(/<p>&nbsp;<\/p>/g, '')
            if (this.sendMessage && this.sendMessage.length > 1) {
              this.sendMessage = this.sendMessage.replaceAll('<a', '<a style="color: #0645AD;" target="_blank" rel="noopener"')
              this.sendMessage = this.sendMessage.replace('<img', '<img style="width: 350px; height: 200px; cursor: zoom-in;" class="open-img-modal"')
              this.sendMessage = this.$refs.badWordsAlert.maskBadWords(this.sendMessage)
              let date = new Date()
              let dd = date.getDate()
              let mm = date.getMonth() + 1
              let yyyy = date.getFullYear()
              let hr = date.getHours()
              let mn = date.getMinutes()
              if (mn < 10) {
                mn = '0' + mn
              }
              const message = {
                name: this.userName,
                role: this.userRole,
                uuid: this.userId,
                text: this.sendMessage,
                date: mm + '/' + dd + '/' + yyyy + ' ' + hr + ':' + mn,
                time: hr + ':' + mn,
                type: this.messageType
              }
              this.$firebaseRefs.messages.push(message)
              this.updateAllUnread()
              this.updateUnread({channelId: this.currentChannel, unread: 0})
              this.sendMessage = ''
              this.editorInstanceId = ''
              if (this.isDirectMessage && this.selectedUserId) {
                await this.loadUpdateDirectChannelPeerMap(this.selectedUserId)
              }
            }
          }
        }
        this.updateTypingStatus(false)
        clearTimeout(this.typingTimeout)
      },
      sendUploadedFile (fileName, uploadedFileLink) {
        if (uploadedFileLink.length > 0) {
          let date = new Date()
          let dd = date.getDate()
          let mm = date.getMonth() + 1
          let yyyy = date.getFullYear()
          let hr = date.getHours()
          let mn = date.getMinutes()
          if (mn < 10) {
            mn = '0' + mn
          }
          const message = {
            name: this.userName,
            role: this.userRole,
            uuid: this.userId,
            text: uploadedFileLink,
            date: mm + '/' + dd + '/' + yyyy + ' ' + hr + ':' + mn,
            time: hr + ':' + mn,
            type: this.messageType,
            isFile: true,
            fileName: fileName
          }
          this.$firebaseRefs.messages.push(message)
          this.updateAllUnread()
        }
      },
      showEditMessageModal (message) {
        this.editMessage = message.text
        this.isEditMessageClicked = true
        this.selectedMessage = message
        this.editorInstanceId = 'editMessageRowId_ifr'
        this.$refs.editMessageModal.show()
      },
      saveEditMessage (isBadWordsNotAllowed, message) {
        let isNotAllowed = this.$refs.badWordsAlert.showPrompt(this.editMessage, isBadWordsNotAllowed)
        if (!isNotAllowed) {
          this.editMessage = this.editMessage.replaceAll(/<p style=.*>&nbsp;<\/p>/g, '').replaceAll(/<p>&nbsp;<\/p>/g, '')
          this.editMessage = this.editMessage.replaceAll('<a', '<a style="color: #0645AD;" target="_blank" rel="noopener"')
          this.editMessage = this.editMessage.replace('<img', '<img style="width: 350px; height: 200px; cursor: zoom-in;" class="open-img-modal"')
          this.editMessage = this.$refs.badWordsAlert.maskBadWords(this.editMessage)
          this.$firebaseRefs.messages.child(message['.key']).update({text: this.editMessage, edited: true})
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully updated the message!'
          })
          this.discardEditMessage()
        }
      },
      discardEditMessage () {
        this.editMessage = ''
        this.selectedMessage = ''
        this.editorInstanceId = ''
        this.isEditMessageClicked = false
        this.$refs.editMessageModal.hide()
      },
      showDeleteMessageModal (message) {
        this.selectedMessage = message
        this.$refs.deleteMessageModal.show()
      },
      deleteMessage () {
        if (this.selectedMessage.uuid === this.userId) {
          if (this.selectedMessage.isFile) {
            let storageRef = storage.ref('files/' + this.userId)
            let spaceRef = storageRef.child(this.selectedMessage.fileName)
            spaceRef.delete().then(() => {
              console.log('file deleted from storage')
            }).catch((error) => {
              console.log('unable to delete file from storage')
            })
          }
          let format = this.selectedMessage.isFile ? 'file!' : 'message!'
          this.$firebaseRefs.messages.child(this.selectedMessage['.key']).remove()
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully deleted the ' + format
          })
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'You do not have the permission to delete this message'
          })
        }
        this.cancelDeleteMessage()
      },
      cancelDeleteMessage () {
        this.selectedMessage = ''
        this.$refs.deleteMessageModal.hide()
      },
      async populateDirectChannelPeerMap () {
        let directChannelPeerMap = await this.loadDirectChannelPeerMap()
        this.userObj.directChannelPeerMap = directChannelPeerMap
      },
      async populateDirectChannelParticipants () {
        let participants = []
        if(_.isEmpty(this.userObj.directChannelPeerMap)) {
          await this.populateDirectChannelPeerMap()
        }
        let map = await this.loadParticipantDisplayNames(Object.keys(this.userObj.directChannelPeerMap))
        for (let key in this.userObj.directChannelPeerMap) {
          let value = map[key]
          let data = {
            userUuid: key,
            displayName: value,
            firstName: value.split(' ')[0]
          }
          participants.push(data)
        }
        this.directChannelParticipants = _.sortBy(participants, 'firstName')
      },
      async populateDirectChannelUsers (courseId) {
        this.directChannelUsers = []
        this.directChannelUsers = await this.loadDirectChannelUsers(courseId)
      },
      showCreateDirectChannelModal () {
        this.$refs.createDirectChannelModal.show()
      },
      async createDirectChannel () {
        let data = await this.loadAddToDirectChannelPeerMap(this.selectedDirectChannelUsers)
        this.userObj.directChannelPeerMap = data
        this.populateDirectChannelParticipants()
        this.cancelCreateDirectChannel()
      },
      cancelCreateDirectChannel () {
        this.directChannelSearchTerm = ''
        this.selectedDirectChannelUsers = []
        this.$refs.createDirectChannelModal.hide()
      },
      isAlreadyAddedForDirectChannel (uuid) {
        let uuids = Object.keys(this.userObj.directChannelPeerMap)
        return uuids.includes(uuid)
      },
      showAllGroupChannels () {
        let elem = '.grp_ch_list'
        $(elem).removeClass('show_less')
        $(elem).addClass('show_more')
      },
      showFewGroupChannels () {
        let elem = '.grp_ch_list'
        $(elem).removeClass('show_more')
        $(elem).addClass('show_less')
      },
      changeType (type) {
        this.messageType = type
      },
      showTextOptions () {
        let elem = '.chat-message-form'
        $(elem).toggleClass('enable_text_tools')
      }
    }
  }
</script>

<style scoped>
  .left-panel-menu {
    width: 90%;
    z-index: 1000;
    position: absolute;
    background: #f5f5f5;
  }

  .current-user {
    pointer-events: none;
    cursor: default;
  }

  .user-avatar-default {
    border: 1px solid #e5e5e5;
    background-color: #9fd5ed;
  }

  .unread-message-status {
    font-weight: bolder;
  }

  .active {
    background: #17b8ee;
    color: #eee;
  }

  .title-participant {
    max-width: calc(100% - 120px) !important;
  }

  .title-participant-widget {
    max-width: 100% !important;
  }

  .section-message-in {
    width: calc(100% - 95px) !important;
  }

  .file-attachment {
    width: 0px;
    visibility: hidden;
  }

  .rich-text-editor-msg-leave-group {
    height: 100% !important;
  }

  .rich-text-editor-send-btn {
    padding: 0px 5px !important;
  }

  #sectionRichTextMessage {
    height: 86px;
    width: calc(100% - 85px);
    padding-left: 6px;
  }

  div[id^="sectionRichTextEditMessage-"] {
    height: 46px;
    padding: 0px 10px;
    border: 1px solid #e6e6e6;
  }

  .edit-name-icon, .delete-group-icon {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/Channel.vue